import React, {useEffect, useState} from 'react';
import {observer} from 'mobx-react';
import {AlertModal, ModalButtons} from 'shared/components/modals';
import {FormattedMessage} from 'react-intl';
import _ from 'lodash';
import {ObjectSelect2} from 'shared/components';

const ShareWithRevieweeModal = observer(({reviewee, isOpen, onClose, onSubmit, options}) => {
  const [selectedReview, setSelectedReview] = useState(null);

  useEffect(() => {
    setSelectedReview(null);
  }, [isOpen]);

  return (
    <AlertModal
      isOpen={isOpen}
      onHide={onClose}
      size='md'
      header='performance_reviews.view.Share'
    >
      <div className='space-y-2'>
        <FormattedMessage
          id='performance_reviews.view.END_REVIEWEE_DESCRIPTION_1'
          values={{revieweeName: _.get(reviewee, 'employee.name')}}
        />
      {options && <ObjectSelect2
        label='performance_reviews.view.Manager Review'
        display='reviewer.name'
        items={options}
        value={selectedReview}
        onChange={setSelectedReview}
      />}
      {!reviewee.canViewAllReviews && <div>
        <FormattedMessage
          id='performance_reviews.view.END_REVIEWEE_DESCRIPTION_2'
          values={{revieweeName: _.get(reviewee, 'employee.name')}}
        />
      </div>}
      </div>
      <ModalButtons
        saveCaption='performance_reviews.view.Share'
        onSave={() => onSubmit(selectedReview)}
        onCancel={onClose}
      />
    </AlertModal>
  );
});

export default ShareWithRevieweeModal;
